// Słownik polski — single source of truth dla struktury.
// Każdy nowy klucz dodawaj tutaj NAJPIERW, potem do en.ts (TS zmusi do uzupełnienia).
export const pl = {
  meta: {
    title: 'Solid Labs PSA | Premium Partner dla MŚP',
    description:
      'Krakowska firma technologiczna. Dostarczamy nowoczesne rozwiązania cyfrowe wspierane sztuczną inteligencją dla małych i średnich przedsiębiorstw.',
  },
  nav: {
    about: 'O nas',
    product: 'Produkty',
    oferta: 'Oferta',
    realizacje: 'Realizacje',
    blog: 'Blog',
    contact: 'Kontakt',
    spottoApp: 'Spotto App',
    logoAria: 'Solid Labs, strona główna',
    logoAlt: 'Solid Labs',
    langPlAria: 'Język polski',
    langEnAria: 'Switch to English',
    mobileToggleOpen: 'Otwórz menu',
    mobileToggleClose: 'Zamknij menu',
  },
  hero: {
    title1: 'Tworzymy rozwiązania',
    title2: 'dla biznesu',
    title3: 'napędzane AI',
    subtitle:
      'Solid Labs PSA to krakowska firma technologiczna. Dostarczamy rozwiązania cyfryzujące procesy biznesowe, wzbogacone mocą sztucznej inteligencji. Naszym flagowym produktem jest Spotto, platforma dla branży sportowej.',
    ctaPrimary: 'Poznaj Spotto',
    ctaSecondary: 'O firmie',
    scrollHint: 'Dowiedz się więcej',
  },
  about: {
    eyebrow: 'O firmie',
    titlePart1: 'Technologia spotyka',
    titlePart2: 'biznes',
    intro:
      'Solid Labs PSA to krakowska firma technologiczna z międzynarodowym doświadczeniem. Specjalizujemy się w cyfryzacji procesów biznesowych i automatyzacji wspieranej sztuczną inteligencją, dla klientów z najbardziej wymagających sektorów. Customer excellence i długoterminowe, partnerskie relacje z klientami to fundament, na którym budujemy każdy projekt.',
    facts: {
      operatingSince: {
        title: 'Działamy od 2022 roku',
        description:
          'Krakowska firma technologiczna w formule Prostej Spółki Akcyjnej. Funkcjonujemy nieprzerwanie od lipca 2022 roku.',
      },
      digitizationAi: {
        title: 'Cyfryzacja + AI',
        description:
          'Doświadczenie w cyfryzacji procesów, analityce danych, wdrożeniach chmurowych oraz automatyzacji opartej na sztucznej inteligencji.',
      },
      implementations: {
        title: 'Mamy ponad 12 wdrożeń',
        description:
          'Zrealizowaliśmy ponad tuzin projektów dla klientów biznesowych, od dużych korporacji po dynamicznie rosnące spółki.',
      },
      crossSector: {
        title: 'Doświadczenie międzysektorowe',
        description:
          'Banking, Finance, TMT, Energy i Retail. Znamy specyfikę i wdrażaliśmy usprawnienia skomplikowanych procesów zakupowych i operacyjnych.',
      },
      solutions: {
        title: 'Realizacje',
        description:
          'Systemy CRM, katalogi produktowe, portale transakcyjne, aplikacje mobilne oraz automatyzacja procesów oparta na danych i AI.',
      },
      international: {
        title: 'Doświadczenie międzynarodowe',
        description:
          'Wieloletnie doświadczenie w projektach międzynarodowych: współpracowaliśmy z firmami Big 4, dużymi spółkami akcyjnymi i innymi podmiotami w Polsce, Europie i USA.',
      },
    },
  },
  privacy: {
    title: 'Polityka prywatności',
    closeAria: 'Zamknij',
    lastUpdated: 'Ostatnia aktualizacja: 11 maja 2026',
  },
  oferta: {
    eyebrow: 'Oferta',
    titlePart1: 'Cyfryzacja dla',
    titlePart2: 'MŚP',
    mission:
      'Naszą misją jest dostarczanie małym i średnim przedsiębiorstwom narzędzi cyfrowych w klasie premium. Upraszczamy, integrujemy i wdrażamy nowoczesne rozwiązania w modelu SaaS, czyli w rekurencyjnym abonamencie, który optymalizuje wydatki inwestycyjne i rozkłada koszty w czasie.',
    pillars: {
      saas: {
        title: 'Produkty SaaS',
        description:
          'Gotowe moduły SaaS, które integrują się z każdą istniejącą stroną bez konieczności przebudowy. Wystarczy podlinkować je do naszego systemu.',
        items: {
          scheduler: {
            title: 'Scheduler',
            desc: 'Pełny moduł rezerwacji kalendarza i zarządzania nim. Gotowy do osadzenia w dowolnym biznesie usługowym.',
          },
          sklep: {
            title: 'PLUGIN COMMERCE',
            desc: 'Moduł sprzedażowy z bramką płatności i łatwą integracją z każdą stroną. Dodaje kanał sprzedaży online bez kosztów inwestycyjnych.',
          },
        },
      },
      transformacje: {
        title: 'Transformacje technologiczne',
        description:
          'Wspieramy biznesy w skalowaniu przez optymalizację procesów sprzedażowych i operacyjnych.',
        items: {
          sales: {
            title: 'Optymalizacja sprzedaży',
            desc: 'Aktywacja kanałów online: szybko, tanio i skutecznie. Łączymy strony, sklepy i automatyzację marketingu.',
          },
          operations: {
            title: 'Optymalizacja operacji',
            desc: 'Automatyzacja procesów wewnętrznych: fakturowanie, obieg dokumentów, raportowanie, integracja systemów.',
          },
        },
      },
      ai: {
        title: 'Automatyzacja z AI',
        description:
          'Wdrożenia AI tam, gdzie wnoszą realną wartość, bez hype’u, z mierzalnym ROI.',
        items: {
          analytics: {
            title: 'Analityka danych',
            desc: 'Dostarczamy wartość przez zrozumienie struktury danych, ich integrację oraz wykorzystanie data insights dla lepszego zarządzania biznesem.',
          },
          integrations: {
            title: 'Integracje AI',
            desc: 'Łączenie modeli językowych z istniejącymi systemami biznesowymi: CRM, ERP, hurtownie danych.',
          },
        },
      },
    },
  },
  product: {
    eyebrow: 'Nasz produkt',
    description1:
      'Platforma, która rewolucjonizuje sposób rezerwacji obiektów sportowych. Znajdź idealne miejsce do uprawiania sportu, zarezerwuj je w kilka sekund i zarządzaj swoimi treningami, wszystko w jednej aplikacji.',
    description2:
      'Dla właścicieli obiektów Spotto to kompleksowe narzędzie do zarządzania rezerwacjami, płatnościami, kalendarzem dostępności i komunikacją z klientami. Transparentne ceny, brak ukrytych opłat.',
    capabilities: {
      search: 'Wyszukiwanie obiektów w okolicy',
      booking: 'Rezerwacja w czasie rzeczywistym',
      payments: 'Bezpieczne płatności online',
      trainers: 'Szukanie trenerów personalnych',
      mobile: 'Aplikacja mobilna iOS i Android',
      panel: 'Panel zarządzania dla właścicieli',
    },
    ctaVisit: 'Przejdź na stronę produktu',
    screens: {
      home: 'Ekran główny',
      explore: 'Przeglądanie obiektów',
      booking: 'Rezerwacja terminu',
      training: 'Zapis na trening',
      shop: 'Sklep',
    },
    carouselAria: 'Wybierz ekran aplikacji',
    // Kafel drugiego produktu w sekcji Produkty. Spotto zostaje flagowcem,
    // Plugin Commerce dostaje własny kafel prowadzący na podstronę.
    plugin: {
      eyebrow: 'Drugi produkt',
      name: 'PLUGIN COMMERCE',
      tagline: 'Sprzedaż online na Twojej stronie',
      description:
        'Gotowy moduł, który uruchamia sprzedaż online na istniejącej stronie w kilka minut: produkty, usługi, a nawet usługi cykliczne w abonamencie. Bez nakładów inwestycyjnych, wyłącznie prowizja naliczana przy sprzedaży.',
      cta: 'Zobacz produkt',
    },
  },
  pluginCommerce: {
    meta: {
      title: 'PLUGIN COMMERCE | Solid Labs PSA',
      description:
        'Gotowy moduł sprzedaży online na Twojej stronie: produkty, usługi i usługi cykliczne. Integracja w kilka minut, bez nakładów inwestycyjnych, wyłącznie prowizja od sprzedaży.',
    },
    eyebrow: 'PLUGIN COMMERCE',
    titlePart1: 'Sprzedaż online',
    titlePart2: 'na Twojej stronie',
    intro:
      'PLUGIN COMMERCE pozwala szybko uruchomić sprzedaż online na dowolnej stronie. Dostajesz panel sterowania, w którym definiujesz swoje produkty, zostajesz partnerem TPAY (podmiotu realizującego płatności), a specjalista IT dodaje 8 linijek kodu do Twojej witryny. Tyle. Kanał sprzedaży online działa.',
    sells: {
      eyebrow: 'Co sprzedasz',
      products: {
        title: 'Produkty',
        desc: 'Towary fizyczne i cyfrowe, vouchery, pakiety. Pełny koszyk i płatność online.',
      },
      services: {
        title: 'Usługi',
        desc: 'Terminy, wejściówki, konsultacje. Klient wybiera i płaci z góry, co zabija no-show.',
      },
      recurring: {
        title: 'Usługi cykliczne',
        desc: 'Abonamenty i karnety w modelu powracającej płatności. Sprzedaż działa 24 na 7.',
      },
    },
    features: {
      eyebrow: 'Dlaczego to działa',
      integration: {
        title: 'Integracja w minuty',
        desc: 'Jeden skrypt na stronie, bez przebudowy. Osadzenie robimy my, Ty tylko wklejasz snippet.',
      },
      payments: {
        title: 'Płatność z góry',
        desc: 'Bramka płatności z kartą i BLIK. Pieniądze na koncie, zanim klient pojawi się na miejscu.',
      },
      brandFit: {
        title: 'Twoja marka, nie nasza',
        desc: 'Widżet dopasowuje się do Twojej strony. Klient zostaje u Ciebie, nie w cudzym katalogu.',
      },
      noInvestment: {
        title: 'Bez inwestycji',
        desc: 'Zero opłaty na start i za wdrożenie. Płacisz wyłącznie prowizję naliczaną przy sprzedaży.',
      },
    },
    ctaDemo: 'Zobacz demo',
    ctaContact: 'Porozmawiajmy o wdrożeniu',
    backToProducts: 'Wróć do produktów',
    demoInvite:
      'Wyklikaj przykładowy snippet strzelnicy i zobacz zakup oczami klienta. To DEMO, więc nic nie płacisz.',
    demo: {
      meta: {
        title: 'PLUGIN COMMERCE: demo | Solid Labs PSA',
        description:
          'Działające demo widżetu PLUGIN COMMERCE osadzonego na stronie.',
      },
      eyebrow: 'Demo na żywo',
      title: 'Widżet osadzony na tej stronie',
      subtitle:
        'Poniżej mamy przykład snippetu dla obiektu strzelnicy. Możesz go wyklikać, żeby zapoznać się z przejściem przez proces zakupu. To jest DEMO, więc nie trzeba nic płacić.',
      backToProduct: 'Wróć do opisu produktu',
      configNeeded: {
        title: 'Snippet DEV nie jest jeszcze podpięty',
        body: 'Uzupełnij dane środowiska DEV (adres loadera, business-id, embed-token, tryb) w konfiguracji strony demo, a widżet zamontuje się w tym miejscu.',
      },
    },
  },
  realizacje: {
    eyebrow: 'Realizacje',
    title: 'Co już zbudowaliśmy',
    subtitle:
      'Produkty i systemy, które zbudowaliśmy i rozwijamy: platforma rezerwacyjna, moduł sprzedaży online oraz asystent AI prowadzący naszą własną sprzedaż.',
    projects: {
      spotto: {
        category: 'Platforma sportowa',
        title: 'Spotto',
        description:
          'Aplikacja mobilna i platforma webowa do rezerwacji obiektów sportowych, zarządzania treningami i łączenia sportowców z trenerami.',
      },
      pluginCommerce: {
        category: 'Moduł sprzedażowy',
        title: 'PLUGIN COMMERCE',
        description:
          'Gotowy moduł, który uruchamia sprzedaż online usług i produktów na istniejącej stronie w kilka minut. Bez nakładów inwestycyjnych na budowę systemu, wyłącznie prowizja naliczana przy sprzedaży.',
      },
      asystent: {
        category: 'Asystent sprzedaży i operacji',
        title: 'Hermes',
        description:
          'Agent, który czyta pocztę, zamienia dyktowane notatki w uporządkowane wpisy o kliencie i pilnuje obiecanych terminów. Prowadzi naszą własną sprzedaż, więc opisujemy go razem z błędami, które po drodze popełnił.',
      },
    },
  },
  blog: {
    meta: {
      title: 'Blog | Solid Labs PSA',
      description:
        'Praktyczne obserwacje z wdrożeń: cyfryzacja procesów, automatyzacja wspierana AI i budowa produktów SaaS dla małych i średnich firm.',
    },
    eyebrow: 'Blog',
    titlePart1: 'Co wiemy',
    titlePart2: 'z wdrożeń',
    subtitle:
      'Piszemy o tym, czego uczymy się przy realnych projektach: cyfryzacji procesów, automatyzacji z AI i budowie Spotto. Bez hype’u, z konkretami.',
    allCategories: 'Wszystkie',
    filterAria: 'Filtruj artykuły według kategorii',
    readingTime: 'min czytania',
    empty: 'Pierwsze artykuły pojawią się tutaj wkrótce.',
    backToList: 'Wszystkie artykuły',
    moreArticles: 'Czytaj dalej',
    readArticle: 'Czytaj artykuł',
    featured: 'Najnowszy',
    translationNotice:
      'Ten artykuł nie ma jeszcze polskiej wersji, poniżej tekst w oryginale.',
    notFound: {
      title: 'Nie znaleźliśmy tego artykułu',
      description:
        'Adres może być nieaktualny albo tekst został przeniesiony. Sprawdź listę wszystkich artykułów.',
      cta: 'Wróć do bloga',
    },
    articleCta: {
      title: 'Ten temat dotyczy Twojej firmy?',
      subtitle:
        'Jeśli mierzysz się z podobnym problemem, odezwij się. Pierwsza rozmowa nic nie kosztuje.',
      button: 'Napisz do nas',
    },
  },
  cta: {
    titlePart1: 'Gotowy na',
    titlePart2: 'współpracę?',
    subtitle:
      'Jeśli prowadzisz biznes sportowy, szukasz partnera technologicznego lub chcesz się dowiedzieć więcej o Spotto, odezwij się do nas.',
    ctaPrimary: 'Napisz do nas',
    ctaSecondary: 'Zobacz Spotto',
  },
  footer: {
    descriptionLine1: 'Krakowska firma technologiczna,',
    descriptionLine2: 'Premium Partner dla Małych i Średnich Przedsiębiorstw.',
    legalForm: 'Prosta Spółka Akcyjna',
    productHeader: 'Produkt',
    companyHeader: 'Firma',
    allRightsReserved: 'Wszystkie prawa zastrzeżone.',
    privacyPolicy: 'Polityka prywatności',
  },
}
